module.exports = __webpack_public_path__ + "img/pop_xinyinghu02@2x.b00d5c21.png";